import { useState, useEffect } from "react";
import axios from "axios";

export default function useObtenerPropuesta(propuestaId) {
  const [propuesta, guardarPropuesta] = useState(undefined);
  const [error, guardarError] = useState(false);

  useEffect(() => {
    const buscarPropuesta = () => {
      axios
        .get("/api/propuestas/" + propuestaId)
        .then((respuesta) => {
          guardarPropuesta(respuesta.data.propuesta);
        })
        .catch((err) => guardarError(true));
    };
    buscarPropuesta();
    return () => {
      guardarPropuesta(undefined);
      guardarError(false);
    };
  }, [propuestaId]);

  return [propuesta, error];
}
